export const GetImageContent = (state = false, action) => {
    switch (action.type) {
        case 'IS_GET_IMAGE_CONTENT':
          return !state
        default:
          return state
    }
}